import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import { Grid, IconButton } from '@mui/material';
import { GridSortDirection } from '@mui/x-data-grid';
import { getNextGridSortDirection } from '@mui/x-data-grid/hooks/features/sorting/gridSortingUtils';

const CustomHeader = ({ params, sortModel, handleSort }) => {
  const currentSortModel = sortModel.find((model) => model.field === params.field);
  const sortingOrder: GridSortDirection[] = ['desc', 'asc'];
  const currentSortDirection = currentSortModel?.sort || null;
  const nextSortDirection =
    currentSortDirection != null
      ? getNextGridSortDirection(sortingOrder, currentSortDirection)
      : undefined;
  return (
    <Grid sx={{ display: 'flex', alignItems: 'center' }}>
      <span>{params.colDef.headerName}</span>
      <IconButton onClick={() => handleSort(params.field, nextSortDirection)} size="small">
        {currentSortDirection === 'asc' && <ArrowUpwardIcon />}
        {currentSortDirection === 'desc' && <ArrowDownwardIcon />}
        {currentSortDirection === null && <SortIcon />}
      </IconButton>
    </Grid>
  );
};

export default CustomHeader;
